import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface ExportSelectionsInput {
    orderId: string;
}

const exportSelections = async (data: ExportSelectionsInput, sessionId: string | null) => {
    return axios.post(`${API_URL}/order/selections/export`, data, {
        headers: {
            Authorization: sessionId
        }
    });
};

export const useExportSelections = () => {
    const sessionContext = useContext(SessionContext);

    return useMutation({
        mutationFn: (data: ExportSelectionsInput) => exportSelections(data, sessionContext?.sessionId ?? null),
        onError: (error) => {
            console.error('Failed to place order:', error);
        }
    });
};
